import { cn } from '@/utils/styles';
import type { Section } from '@viome/viome-base/src/api/Strapi/StrapiTypes';

type AddonHowToUseItProps = {
  section: Section;
  className?: string;
  notesClassName?: string;
};

export const AddonHowToUseIt = ({
  section,
  className,
  notesClassName,
}: AddonHowToUseItProps) => {
  return (
    <div className={className}>
      <h2 className="font-sans text-xl font-medium text-[#111] tracking-tight mb-5">
        {section.title}
      </h2>
      <div className="flex flex-col">
        {section.items?.map((step, idx) => (
          <div
            key={idx}
            className={cn(
              'flex gap-3.5 pt-3.5',
              idx > 0 && 'border-t border-gray-100',
            )}
          >
            <div className="flex flex-col flex-1 min-w-0 pb-4">
              <p className="font-sans text-sm font-medium text-[#111] tracking-[-0.14px]">
                {step.title}
              </p>
              <p className="font-sans font-light text-sm leading-[130%] text-tertiary mt-1">
                {step.description.split('**').map((part, i) =>
                  i % 2 === 1 ? (
                    <span key={i} className="font-semibold text-[#111]">
                      {part}
                    </span>
                  ) : (
                    <span key={i}>{part}</span>
                  ),
                )}
              </p>
              {step.notes && (
                <div
                  className={cn(
                    'bg-white rounded-[6px] px-3 py-2.5 mt-2.5',
                    notesClassName,
                  )}
                >
                  <p className="font-sans font-light text-sm leading-[130%] text-tertiary">
                    {step.notes}
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
